// extracted by mini-css-extract-plugin
module.exports = {"root":"Left_root__QT2x4","searchInput":"Left_searchInput__ChSf0","listCoin":"Left_listCoin__UGDRa","active":"Left_active___ytXK","btnDrawer":"Left_btnDrawer__zg4x3"};